import { atom } from "jotai";

export const PJ_SEARCH_TYPES = {
  A_RENOUVELER: "A_RENOUVELER",
  EFFECTUES: "EFFECTUES",
  RESILIES: "RESILIES",
};

export const pjListAtom = atom(null);
export const isLoadingPjListAtom = atom(false);
export const pjListFiltersAtom = atom({
  searchType: PJ_SEARCH_TYPES.A_RENOUVELER,
  page: 1,
  filters: {
    renewableInNbDays: 30,
  },
});
export const isPjListInitAtom = atom(false);
